module.exports = __webpack_public_path__ + "static/img/sub-logo.90075ff.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sub-logo.jpeg
// module id = 77Op
// module chunks = 1